export const TableDataRowColor = Object.freeze({
    No: 'no',
    Red: 'red',
    Orange: 'orange',
    Green: 'green',
});
